import { render, staticRenderFns } from "./CardSkeleton.vue?vue&type=template&id=15b8e19e&scoped=true"
var script = {}
import style0 from "./CardSkeleton.vue?vue&type=style&index=0&id=15b8e19e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b8e19e",
  null
  
)

export default component.exports